import { Question } from "../types";

export function isEmqQuestion(question?: Question | null): boolean {
  return question?.type?.toLowerCase?.() === "emq" || !!question?.emqPart;
}

/** Sibling parts for the same EMQ grouping, ordered by partOrder. */
export function getEmqSiblingQuestions(
  questions: Question[],
  question: Question,
): Question[] {
  const groupingId = question.emqPart?.groupingId;
  if (groupingId == null) {
    return [question];
  }
  return questions
    .filter((q) => q.emqPart?.groupingId === groupingId)
    .sort((a, b) => (a.emqPart?.partOrder ?? 0) - (b.emqPart?.partOrder ?? 0));
}

export function isLastEmqPart(question?: Question | null): boolean {
  const partOrder = question?.emqPart?.partOrder;
  const partsCount = question?.emqPart?.partsCount;
  return (
    partOrder != null && partsCount != null && partOrder === partsCount
  );
}

/** Parts in the EMQ group that still need an answer selected. */
export function getMissingEmqParts(
  siblings: Question[],
  selectedAnswers: { [questionId: number]: number | undefined },
): Question[] {
  return siblings.filter((s) => selectedAnswers[s.id] === undefined);
}

export function getMissingEmqPartOrders(
  siblings: Question[],
  selectedAnswers: { [questionId: number]: number | undefined },
): Array<number | string> {
  return getMissingEmqParts(siblings, selectedAnswers).map(
    (s) => s.emqPart?.partOrder ?? "?",
  );
}

/** True when every sibling part has a selected answer. */
export function areAllEmqPartsAnswered(
  siblings: Question[],
  selectedAnswers: { [questionId: number]: number | undefined },
): boolean {
  return (
    siblings.length > 0 &&
    getMissingEmqParts(siblings, selectedAnswers).length === 0
  );
}

/** Whether every part in an EMQ group has been submitted. */
export function isEmqGroupSubmitted(
  siblings: Question[],
  submittedQuestionIds: Set<number>,
): boolean {
  return (
    siblings.length > 0 &&
    siblings.every((sibling) => submittedQuestionIds.has(sibling.id))
  );
}
